import { lazy, Suspense, useState } from "react";
import LoadScripts from './components/LoadScripts';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom'
import Header from './components/Header';
import ChatWidget from "./components/ChatWidget";
import WelcomePopup from "./components/WelcomePopup";
function App() {
  const Home = lazy(() => import('./pages/Home'));
  const Product = lazy(() => import('./pages/product'));
  const CartItems = lazy(() => import('./pages/CartItems'));
  const Wishlist = lazy(() => import('./pages/Wishlist'));
  const CheckOut = lazy(() => import('./pages/CheckOut'));
  const Completion = lazy(() => import('./pages/Completion'));
  const Contact = lazy(() => import('./pages/Contact'));
  const Shop = lazy(() => import('./pages/Shop'));
  const About = lazy(() => import('./pages/About'));
  const Blogs = lazy(() => import('./pages/Blogs'));
  const TrackOrder = lazy(() => import('./pages/TrackOrder'));
  const StoreLocator = lazy(() => import('./pages/StoreLocator'));
  const NotFound = lazy(() => import('./pages/NotFound'));
  const PrivacyPolicy = lazy(() => import('./pages/PrivacyPolicy'));
  const TermsAndConditions = lazy(() => import('./pages/TermsCondition'));
  const ReturnPolicy = lazy(() => import('./pages/ReturnPolicy'));
  const CODCities = lazy(() => import('./pages/CODCities'));

  return (
    <>
      {/* <Router> */}

        <Suspense fallback={
          <div id="loading">
            <div id="loading-center">
              <div id="loading-center-absolute">
                {/* loading content here */}
                <div className="tp-preloader-content">
                  <div className="tp-preloader-logo">
                    <div className="tp-preloader-circle">
                      <svg width={190} height={190} viewBox="0 0 380 380" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <circle stroke="#D9D9D9" cx={190} cy={190} r={180} strokeWidth={6} strokeLinecap="round" />
                        <circle stroke="red" cx={190} cy={190} r={180} strokeWidth={6} strokeLinecap="round" />
                      </svg>
                    </div>
                    <img src="/assets/img/logo/preloader/logo122.png" alt="preloader-icon" style={{ width: '150px' }} />
                  </div>
                  <p className="tp-preloader-subtitle">Loading</p>
                </div>
              </div>
            </div>
          </div>
        }>
          <ChatWidget />
          <WelcomePopup />
          <Routes>
            <Route exact path="/" element={<Home />} />
            <Route exact path="/product/:id/:slug" element={<Product />} />
            <Route exact path='/cartItems' element={<CartItems />} />
            <Route exact path='/wishlist' element={<Wishlist />} />
            <Route exact path='/checkout' element={<CheckOut />} />
            <Route exact path='/completion' element={<Completion />} />
            <Route exact path='/contactus' element={<Contact />} />
            <Route exact path='/shop' element={<Shop />} />
            <Route exact path='/aboutus' element={<About />} />
            <Route exact path='/blogs' element={<Blogs />} />
            <Route exact path='/trackOrder' element={<TrackOrder />} />
            <Route exact path='/storeLocator' element={<StoreLocator />} />
            <Route exact path='/privacyPolicy' element={<PrivacyPolicy />} />
            <Route exact path='/termsconditions' element={<TermsAndConditions />} />
            <Route exact path='/returnPolicy' element={<ReturnPolicy />} />
            <Route exact path='/codcities' element={<CODCities />} />
            <Route path="*" element={<NotFound />} />
          </Routes>
        </Suspense>
      {/* </Router> */}
    </>

  )
}

export default App;